import React from "react";
import Login from "./pages/login/Login";
import ResetPassword from "./pages/resetPassword/ResetPassword";
import Users from "./pages/users/Users";
import Organizations from "./pages/organizations/Organizations";
import "./App.css";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { MuiThemeProvider, createTheme, StylesProvider } from "@material-ui/core/styles";
import { ThemeProvider } from "@mui/material";
import SideBar from "./components/SideBar";
import axios from "axios";
import MonitoringForm from "./pages/Monitoring/MonitoringFormPage";
import MonitoringDetailsPage from "./pages/Monitoring/MonitoringApplicationDetailPage";
import MonitoringApprovedDetailsPage from "./pages/Monitoring/MonitoringApprovedDetailPage";
import Report from "./pages/report/Report";
import Profile from "./pages/profile/Profile";
import MonitoringRoute from "./providers/MonitoringRoute";
import CustomTheme from "./providers/theme";
import MonitoringUpdateForm from "./pages/Monitoring/MonitoringUpdate";
import MonitoringAgreementDetailPage from "./pages/Monitoring/MonitoringAgreementDetailPage";
import MonitoringTabs from "./pages/Monitoring/MonitorigTabs";
import MonitoringUniversalPage from "./pages/Monitoring/MonitoringUniversalPage";
import MonitoringCgsPage from "./pages/Monitoring/MonitoringCgsPage";
import MonitoringCgsAgreementDetailPage from "./pages/Monitoring/MonitoringCgsAgreementDetailPage";
import MonitoringCgsStartForm from "./pages/Monitoring/MonitoringCgsStart";
import MonitoringCgsUpdateForm from "./pages/Monitoring/MonitoringCgsUpdate";
import MonitoringCgsApplicantDetailPage from "./pages/Monitoring/MonitoringCgsApplicationDetailPage";
import MonitoringCgsRoute from "./providers/MonitoringCgsRoute";
import { DialogProvider } from "./hooks/useDialog";
import AssignmentsPage from "./pages/assignments/AssignmentsPage";
import MonitoringCgsTabs from "./pages/Monitoring/MonitorigTabs";

axios.defaults.baseURL = `${process.env.REACT_APP_BASE_URL}`;
axios.defaults.withCredentials = true;

let isRefreshing = false;
let refreshSubscribers = [];
const onRefreshed = () => { refreshSubscribers.forEach((cb) => cb()); refreshSubscribers = []; };
const addRefreshSubscriber = (cb) => refreshSubscribers.push(cb);

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const url = originalRequest.url || "";
    const isAuthEndpoint = url.includes("/auth/refresh") || url.includes("/auth/signin") || url.includes("/auth/me");
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !isAuthEndpoint
    ) {
      if (isRefreshing) {
        return new Promise((resolve) => {
          addRefreshSubscriber(() => resolve(axios(originalRequest)));
        });
      }
      originalRequest._retry = true;
      isRefreshing = true;
      try {
        await axios.post("/auth/refresh");
        onRefreshed();
        return axios(originalRequest);
      } catch {
        refreshSubscribers = [];
        window.dispatchEvent(new CustomEvent("auth:logout"));
        return Promise.reject(error);
      } finally {
        isRefreshing = false;
      }
    }
    return Promise.reject(error);
  }
);

const theme = createTheme({
  typography: {
    fontFamily: "Title",
  },
  palette: {
    primary: {
      main: "#2c5b94",
    },
    secondary: {
      main: "#142e4c",
    },
  },
});

function AppRoutes() {
  const { user, loading } = useAuth();
  const { defaultTheme } = CustomTheme();

  if (loading) {
    return null; // or a full-screen spinner
  }

  return (
    <StylesProvider injectFirst>
      <MuiThemeProvider theme={theme}>
        <ThemeProvider theme={defaultTheme}>
          <DialogProvider>
            <Router>
              {user ? (
                <div style={{ display: "flex" }}>
                  <SideBar />
                  <div className="app">
                    <Switch>
                      <Route exact path="/" render={() => <Redirect to="/monitoring/cgs" />} />
                      <Route exact path="/monitoring" render={() => <Redirect to="/monitoring/universal" />} />
                      <Route exact path="/monitoring/universal" component={MonitoringUniversalPage} />
                      {/* <Route exact path="/monitoring/cgs" component={MonitoringCgsTabs} /> */}
                      <Route exact path="/monitoring/cgs" component={MonitoringCgsPage} />
                      <MonitoringRoute path="/monitoring-form" component={MonitoringForm} />
                      <MonitoringRoute path="/monitoring-update-form/:id" component={MonitoringUpdateForm} />
                      <MonitoringCgsRoute path="/monitoring-update-cgs-form/:id" component={MonitoringCgsUpdateForm} />
                      <MonitoringCgsRoute path="/monitoring-start-cgs-form/:id" component={MonitoringCgsStartForm} />
                      <MonitoringRoute path="/monitoring-details/:id" component={MonitoringDetailsPage} />
                      <MonitoringCgsRoute path="/monitoring-details-cgs/:id" component={MonitoringCgsApplicantDetailPage} />
                      <MonitoringRoute path="/monitoring-approved-details/:id" component={MonitoringApprovedDetailsPage} />
                      <MonitoringRoute path="/monitoring-agreement-details/:id" component={MonitoringAgreementDetailPage} />
                      <MonitoringCgsRoute path="/monitoring-agreement-details-cgs/:id" component={MonitoringCgsAgreementDetailPage} />
                      <Route exact path="/organizations" component={Organizations} />
                      <Route exact path="/assignments" component={AssignmentsPage} />
                      <Route exact path="/users" component={Users} />
                      <Route exact path="/report" component={Report} />
                      <Route exact path="/profile" component={Profile} />
                    </Switch>
                  </div>
                </div>
              ) : (
                <Switch>
                  <Route exact path="/reset/:email/:token" component={ResetPassword} />
                  <Route path="/" component={Login} />
                </Switch>
              )}
            </Router>
          </DialogProvider>
        </ThemeProvider>
      </MuiThemeProvider>
    </StylesProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;
